export const isComparisonLayerDisabled = (layerType, {
  hasHistoricalAmbient = false,
  hasImageAmbient = false,
  hasHistoricalHdAmbient = false,
  hasImageAmbientHd = false,
  soilMapStatus = 'idle',
  yieldMapStatus = 'empty',
} = {}) => {
  switch (layerType) {
    case 'ambient': return !hasHistoricalAmbient
    case 'imageAmbient': return !hasImageAmbient
    case 'ambientHd': return !hasHistoricalHdAmbient
    case 'imageAmbientHd': return !hasImageAmbientHd
    case 'soil_map': return !['idle', 'loading', 'available'].includes(soilMapStatus)
    case 'yield_map': return yieldMapStatus !== 'available'
    default: return false
  }
}

export const isComparisonHdProductDisabled = ({
  accessEnabled = false,
  isHdProduct = false,
  selectionPending = false,
} = {}) => isHdProduct && (!accessEnabled || selectionPending)

export const shouldEnhanceComparisonImageLayer = (layerType, enhanced) =>
  Boolean(enhanced) && ['evi', 'ndvi', 'ndre'].includes(layerType)
